import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { recurringStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
  isUpfrontPaymentRequiredForTrial,
}) =>
  priceType === paywallPriceTypes.subscription &&
  hasUpfrontPayment &&
  hasTrialPeriod &&
  isUpfrontPaymentRequiredForTrial;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  trialPeriodDays,
  watch,
}) => [
  "upfront_then_trial_then_subscription",
  {
    recurring_frequency:
      buildOptions.frequencies[
        watch("billing_frequency")
      ].as_phrase.toLowerCase(),
    recurring_amount: formatPaywallCurrencyAmount(
      currency,
      mapCurrencyAmountStrToInt(watch("amount")),
    ),
    upfront_payment_amount: formatPaywallCurrencyAmount(
      currency,
      mapCurrencyAmountStrToInt(watch("upfront_payment_amount")),
    ),
    trial_period_days: `${trialPeriodDays}`,
  },
];

export const upfrontThenTrialThenSubscription: NoticeScenario = {
  matcher,
  stateValidator: recurringStateValidator,
  messagePropsResolver,
};
